import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import { isMultilineColumn } from '../columns/columnsState';
import styles from '../table.module.scss';
export function TableRowCell(param) {
    let { column, row, isFrozen, isFrozenEdge, left, pending, now, editing, cellTestId, valueTestId, trailing = false } = param;
    var _editing_getCellError;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": cellTestId,
        className: cn(styles.rowCell, {
            [styles.trailingCell]: trailing,
            [styles.editableCell]: 'isEditable' in column.column && column.column.isEditable === true,
            [styles.multilineCell]: isMultilineColumn(column.column),
            [styles.linkCell]: column.column.type === 'link',
            [styles.frozen]: isFrozen,
            [styles.scrolledFrozenEdge]: isFrozenEdge,
            [styles.alignCenter]: column.hAlign === 'center',
            [styles.alignEnd]: column.hAlign === 'end'
        }),
        style: {
            width: column.width,
            left: isFrozen ? left : undefined
        },
        children: /*#__PURE__*/ _jsx(SchemaCell, {
            column: column.column,
            row: row,
            now: now,
            weight: column.isMain ? 'normal' : undefined,
            pending: pending && column.column.showsLoaderWhilePending === true,
            editing: editing != null ? {
                isEditing: editing.editingColumnId === column.id,
                errorText: (_editing_getCellError = editing.getCellError) === null || _editing_getCellError === void 0 ? void 0 : _editing_getCellError.call(editing, column.id),
                bi: {
                    name: 'edit_cell'
                },
                onStart: ()=>editing.onStart(column.id),
                onCommit: (value)=>editing.onCommit(column.id, value),
                onCancel: editing.onCancel
            } : undefined,
            testId: valueTestId
        })
    });
}
